import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 2rem;
  @media (max-width: 768px) {
    align-items: center;
  }
`;

export const GridCard = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 2rem;
  padding-bottom: 1rem;

  @media (max-width: 1024px) {
    grid-template-columns: 18rem 18rem 18rem;
  }

  @media (max-width: 768px) {
    grid-template-columns: 20rem 20rem;
  }

  @media (max-width: 520px) {
    grid-template-columns: 24rem;
  }
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  > img {
    width: 15rem;
  }

  > p {
    font-size: 1rem;
    color: #323232;
    margin-top: 0.5rem;
    text-align: center;
  }
`;
